import cn from 'classnames';
import { ForwardedRef, forwardRef } from 'react';
import Mask, { Props } from 'react-input-mask';
import styles from './keto-text-field.module.css';

export interface SharedInputProps {
  error?: boolean;
  errorMessage?: string;
}

export interface TextInputProps
  extends React.DetailedHTMLProps<
      React.InputHTMLAttributes<HTMLInputElement>,
      HTMLInputElement
    >,
    SharedInputProps {
  variant?: 'textField';
}

export interface TextMaskProps extends Props, SharedInputProps {
  variant?: 'mask';
}

export type TextFieldProps = TextInputProps | TextMaskProps;

function KetoTextField(
  {
    error,
    errorMessage,
    className,
    variant = 'textField',
    ...props
  }: TextFieldProps,
  // eslint-disable-next-line
  ref: ForwardedRef<any>,
) {
  const render = () => {
    switch (variant) {
      case 'textField': {
        return (
          <input
            ref={ref}
            {...props}
            className={cn(styles.input, {
              [styles.input_error]: error,
            })}
          />
        );
      }

      case 'mask': {
        return (
          <Mask
            ref={ref}
            {...(props as TextMaskProps)}
            className={cn(styles.input, {
              [styles.input_error]: error,
            })}
          />
        );
      }

      default:
        return null;
    }
  };

  return (
    <div className={cn(className, styles.wrapper)}>
      {render()}
      {error && <span className={styles.error}>{errorMessage}</span>}
    </div>
  );
}

export default forwardRef(KetoTextField);
